export const VEHICLE_SUFFIX_LENGTH = 4;
export const CHASSIS_SUFFIX_LENGTH = 6;
export const VEHICLE_SEARCH_MAX_CHARS = VEHICLE_SUFFIX_LENGTH;
export const CHASSIS_SEARCH_MAX_CHARS = CHASSIS_SUFFIX_LENGTH;

export const VEHICLE_SUFFIX_VALIDATION_MSG =
  "Please enter the last 4 digits of the vehicle number.";
export const CHASSIS_SUFFIX_VALIDATION_MSG =
  "Please enter the last 6 characters of the chassis number.";

/** @deprecated Use VEHICLE_SEARCH_MAX_CHARS / CHASSIS_SEARCH_MAX_CHARS */
export const SEARCH_INPUT_MAX_CHARS = VEHICLE_SEARCH_MAX_CHARS;
/** @deprecated Find Vehicles no longer searches by mobile in the vehicle field */
export const MIN_SEARCH_CHARS = VEHICLE_SUFFIX_LENGTH;
/** @deprecated Find Vehicles no longer searches by mobile */
export const MIN_PHONE_SEARCH_DIGITS = 6;

export function digitsOnly(value) {
  return String(value || "").replace(/\D/g, "");
}

/** Vehicle field: last 4 registration digits only. */
export function sanitizeVehicleSuffixInput(value) {
  return digitsOnly(value).slice(0, VEHICLE_SUFFIX_LENGTH);
}

/** Chassis field: last 6 alphanumeric characters only. */
export function sanitizeChassisSuffixInput(value) {
  return String(value || "")
    .replace(/[^a-zA-Z0-9]/g, "")
    .toUpperCase()
    .slice(0, CHASSIS_SUFFIX_LENGTH);
}

/** @deprecated Use sanitizeVehicleSuffixInput */
export function sanitizeVehicleOrPhoneInput(value, maxLen = VEHICLE_SEARCH_MAX_CHARS) {
  return sanitizeVehicleSuffixInput(value).slice(0, maxLen);
}

/** @deprecated Mobile search removed from Find Vehicles */
export function isPhoneLikeSearch(_value) {
  return false;
}

export function getFindVehiclesValidationMessage(
  draftVehicle,
  draftChassis,
  preference = "vehicle"
) {
  const v = digitsOnly(draftVehicle);
  const c = sanitizeChassisSuffixInput(draftChassis);
  const vPartial = v.length > 0 && v.length < VEHICLE_SUFFIX_LENGTH;
  const cPartial = c.length > 0 && c.length < CHASSIS_SUFFIX_LENGTH;

  if (!vPartial && !cPartial) return "";

  if (vPartial && cPartial) {
    return preference === "chassis"
      ? CHASSIS_SUFFIX_VALIDATION_MSG
      : VEHICLE_SUFFIX_VALIDATION_MSG;
  }
  if (vPartial) return VEHICLE_SUFFIX_VALIDATION_MSG;
  return CHASSIS_SUFFIX_VALIDATION_MSG;
}

/** Pick vehicle vs chassis when both suffix lengths are satisfied. */
export function resolveActiveSearch(draftVehicle, draftChassis, preference) {
  const v = digitsOnly(draftVehicle);
  const c = sanitizeChassisSuffixInput(draftChassis);
  const vReady = v.length === VEHICLE_SUFFIX_LENGTH;
  const cReady = c.length === CHASSIS_SUFFIX_LENGTH;

  if (vReady && cReady) {
    return preference === "chassis"
      ? { mode: "chassis", normalized: c }
      : { mode: "vehicle", normalized: v };
  }
  if (vReady) return { mode: "vehicle", normalized: v };
  if (cReady) return { mode: "chassis", normalized: c };
  return null;
}

/** True when id is a persisted repo_cases row (numeric BIGINT or legacy 24-hex). Excel-only rows use `${batchId}-${rowIndex}`. */
export function isPersistedCaseId(id) {
  const s = String(id || "").trim();
  if (!s) return false;
  if (/^[1-9]\d{0,18}$/.test(s)) return true;
  return /^[a-f0-9]{24}$/i.test(s);
}

/** @deprecated Use isPersistedCaseId — name kept so existing imports keep working. */
export function isMongoCaseId(id) {
  return isPersistedCaseId(id);
}

export const getItems = (response) => {
  if (Array.isArray(response?.data?.items)) return response.data.items;
  if (Array.isArray(response?.items)) return response.items;
  if (Array.isArray(response?.data)) return response.data;
  return [];
};

export const safeValue = (value) => {
  if (value === null || value === undefined || value === "") return "-";
  return value;
};

export const getFullAddress = (item) => {
  const parts = [
    item.addressLine1,
    item.addressLine2,
    item.city,
    item.state,
    item.pincode,
  ].filter(Boolean);

  return parts.length ? parts.join(", ") : "-";
};

export const getShareMessage = (item) => {
  return `Vehicle Confirmation Request

Customer Name: ${safeValue(item.customerName)}
Mobile Number: ${safeValue(item.mobileNumber)}
Alternate Mobile Number: ${safeValue(item.alternateMobileNumber)}
Vehicle Number: ${safeValue(item.vehicleNumber)}
Engine Number: ${safeValue(item.engineNumber)}
Chassis Number: ${safeValue(item.chassisNumber)}
Reference Number: ${safeValue(item.referenceNumber)}
Vehicle Brand: ${safeValue(item.vehicleBrand)}
Vehicle Model: ${safeValue(item.vehicleModel)}
Full Address: ${getFullAddress(item)}
City: ${safeValue(item.city)}
State: ${safeValue(item.state)}
Pincode: ${safeValue(item.pincode)}
Loaded details: ${safeValue(item.loadedDetail || item.loadedShort)}
`;
};
